
































































































































































































import {Vue, Component} from 'vue-property-decorator';
import EForm from "@/components/datatable/EForm.vue";
import Id from "@/components/inputs/Id.vue";
import TextField from "@/components/inputs/TextField.vue";
import Decimal from "@/components/inputs/Decimal.vue";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import {store} from "@/store";
import { UygulaIslemTuru } from '@/enum/UygulaIslemTuru';

class Masraf {
  id!: number;
  isim!: string;
  tutar!: number | null;
  takibe_ekle!: boolean | undefined;
  kapakta_gorunsun!: boolean | undefined;
  gayri_resmi!: boolean | undefined;
  makbuzda_gorunsun!: boolean | undefined;
  masraf_cesidi_alani!: 'haciz' | 'satis' | 'tebligat' | undefined;
  uygulandi_mi!: boolean;
  kodu!: string;
}

@Component({
  computed: {
    store() {
      return store
    }
  },
  components: {DeleteButton, Decimal, TextField, Id, EForm}
})
export default class Masraflar extends Vue {
  masrafDialog: boolean = false;
  masrafAction: string = this.$store.state.icwApiUrl + 'admin/masraf';
  masrafData = new Masraf();
  masrafTitle: string = "";
  masraflarLoading: boolean = true;
  masraflarHeaders = [
    {text: "Id", value: "id"},
    {text: "İsim", value: "isim"},
    {text: "Tutar", value: "tutar"},
    {text: "Takibe Eklensin", value: "takibe_ekle"},
    {text: "Kapakta Görünsün", value: "kapakta_gorunsun"},
    {text: "Gayri Resmi", value: "gayri_resmi"},
    {text: "Makbuzda Görünsün", value: "makbuzda_gorunsun"},
    {text: "Masraf Çeşidi Alanı", value: "masraf_cesidi_alani"},
    {text: "Uygulandı Mı", value: "uygulandi_mi"},
    {text: "Kodu", value: "kodu"},
    {text: "İşlemler", value: "actions"}
  ];
  masraflar = [];
  masrafSearch = "";


  get uygulanmamisMasrafSayisi(): number {
    return this.masraflar.filter((masraf: Masraf) => !masraf.uygulandi_mi).length;
  }

  mounted() {
    this.loadMasraflar();
  }

  async loadMasraflar() {
    try {
      this.masraflarLoading = true;
      this.masraflar = (await this.$http.get(this.$store.state.icwApiUrl + 'admin/masraflar')).data;
    } catch (e) {
      console.error('HATA ---: ', e);
    } finally {
      this.masraflarLoading = false;
    }
  }

  editMasraf(item: Masraf) {
    this.masrafTitle = "Düzenle";
    this.masrafData = item;
    this.masrafAction = this.$store.state.icwApiUrl + 'admin/masraf/' + item.id;
    this.masrafDialog = true;
  }

  addMasraf() {
    this.masrafTitle = "Ekle";
    this.masrafData = new Masraf();
    this.masrafData.tutar = null;
    this.masrafAction = this.$store.state.icwApiUrl + 'admin/masraf';
    this.masrafDialog = true;
  }

/*  async uygulaMasraf() {
    try {
      await this.$http.post(this.$store.state.icwApiUrl + 'admin/panel-uygula-buton/masraf_cesitleri', {
        islem_turu: UygulaIslemTuru.GUNCELLE
      });
      this.$toast.success('Masraflar başarıyla uygulandı.');
    } catch (e) {
      console.error('HATA ---: ', e);
      this.$toast.error('Masrafları uygularken hata oluştu. (' + e.message + ')');
    } finally {
      await this.loadMasraflar();
    }
  }*/

  onFormSuccess(data: any) {
    // Masrafları yeniden yükle
    this.loadMasraflar();
    // Dialog'u kapat
    this.masrafDialog = false;
  }
}
